import { SET_SUMMARY_FILTERED_OPTIONS } from "../../constants/kpiSummaryDashboardEnhancement/kpiSummaryScenarioAdvanceSearchModalConstants";

const defaultData = {
    payloadData: {},
};

export default (state = defaultData, action) => {
    // console.log("reducer data", action)
    switch (action.type) {
        case SET_SUMMARY_FILTERED_OPTIONS:
            return {
                payloadData: action.payloadData,
            };
        default:
            return state;
    }
};
